import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_talent-match-304/artifacts/w2pnjd4z_4F63405D-91D9-42AD-A592-65AF89FFF01A.png';

const Logo = ({ size = 'md', inverted = false }) => {
  const sizes = {
    sm: 'h-9',
    md: 'h-12',
    lg: 'h-14',
  };
  return (
    <Link to="/" className="flex items-center gap-2 group">
      <img src={LOGO_URL} alt="HM Talent" className={`${sizes[size]} w-auto object-contain group-hover:scale-105 transition-transform`} />
    </Link>
  );
};

export default Logo;
